import React from 'react';
import {Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {CREATE_SUPPLIER} from "../../../constants/eInvoicePermissions";

function SupplierListPageActions() {
    const navigate = useNavigate();
    const {hasEInvoicePermission} = usePermissions();
    const accessDeniedMessage = useAccessDeniedMessage();
    const canCreate = hasEInvoicePermission(CREATE_SUPPLIER);
    const handleCreateAction = () => {
        navigate('/suppliers/create');
    };

    return (
        <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
            <Button
                id="create-supplier"
                key="add-new-Supplier"
                variant="contained"
                color="primary"
                disabled={!canCreate}
                onClick={handleCreateAction}
            >
                {'+ Create New Supplier'}
            </Button>
        </PermissionDeniedWrapper>
    );
}

export default SupplierListPageActions;
